// extracted by mini-css-extract-plugin
export var deleteModal = "_fq-0";